export default __webpack_public_path__ + "static/article-which-credit-card-is-best-for-you-8d428139b2fbc8d81fad07d08fa1202c.jpg";